import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { P00062ModeFonctionnementTemperature } from '../../../Enum/P00062ModeFonctionnementTemperature';
import { P00062ModeFonctionnementRegulation } from '../../../Enum/P00062ModeFonctionnementRegulation';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { SlideModalController } from '../../../../../../../slide-modal.service';

@Component({
  selector: 'app-p00062-chauffage-mise-en-oeuvre-pac',
  templateUrl: './p00062-chauffage-mise-en-oeuvre-pac.component.html',
  styleUrls: ['./p00062-chauffage-mise-en-oeuvre-pac.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00062ChauffageMiseEnOeuvrePacComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalService: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description:
          'P00062.installation.parampac.modeFonctionnementRegulation.information',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00062ModeFonctionnementTemperature =
    P00062ModeFonctionnementTemperature;
  protected readonly P00062ModeFonctionnementRegulation =
    P00062ModeFonctionnementRegulation;
}
